import React from 'react'

import GroupWrapper from '../../components/GroupWrapper'
import Flex from '../../../../../components/layouts/Flex'
import RecruitmentStageFunnelChart from './RecruitmentStageFunnelChart'
import ChannelsChart from './ChannelsChart'
import KPIChart from './KPIChart'
import TalentPoolChart from './TalentPoolChart'

const OverviewCharts = () => {
    return (
        <GroupWrapper title="Charts - Overview">
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentStageFunnelChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <ChannelsChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <KPIChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <TalentPoolChart />
            </Flex>
        </GroupWrapper>
    )
}

export default OverviewCharts
